import React from "react"
import AccountLimit from "../../../../state/account-limit/AccountLimit"
import InvoiceCreationButton from "./InvoiceCreationButton"

interface OwnProps {
    accountLimits: AccountLimit
}

const SubscriptionCreationButton = (props: OwnProps) => {
    return (
        <InvoiceCreationButton
            accountLimits={props.accountLimits}
            recurring={true}
        />
    )
}

export default SubscriptionCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/SubscriptionCreationButton.tsx